import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Drawer, Typography, Avatar } from '@mui/material';

import { useAuthUser } from 'react-auth-kit';
import useResponsive from '../../hooks/useResponsive';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import { NavSectionVertical } from '../../components/nav-section';
//
import navConfig from './NavConfig';
import Label from '../../components/Label';
import useNotificationCount from '../../store/useNotificationCount';

const DRAWER_WIDTH = 260;

const RootStyle = styled('div')(({ theme }) => ({
	[theme.breakpoints.up('lg')]: {
		flexShrink: 0,
		width: DRAWER_WIDTH,
	},
}));

const AccountStyle = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	padding: theme.spacing(1.5, 1),
	borderRadius: Number(theme.shape.borderRadius) * 1.5,
	backgroundColor: theme.palette.grey[500_12],
}));

function useForceUpdate() {
	// eslint-disable-next-line prefer-const
	let [value, setState] = useState(true);
	return () => setState(!value);
}

const DashboardSidebar = ({ isOpenSidebar, onCloseSidebar }) => {
	const { pathname } = useLocation();

	const forceUpdate = useForceUpdate();

	const auth = useAuthUser();

	const isDesktop = useResponsive('up', 'lg');

	const { notificationChatCount } = useNotificationCount((state) => ({
		notificationChatCount: state.notificationChatCount,
	}));

	useEffect(() => {
		forceUpdate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [notificationChatCount]);

	useEffect(() => {
		navConfig[0].items[2].info = notificationChatCount ? (
			<Label color="error">{notificationChatCount}</Label>
		) : null;

		if (isOpenSidebar) {
			onCloseSidebar();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname, notificationChatCount]);

	const renderContent = (
		<Scrollbar
			sx={{
				height: 1,
				'& .simplebar-content': { height: 1, display: 'flex', flexDirection: 'column' },
			}}
		>
			<Box
				sx={{
					px: 1.5,
					py: 1.5,
					display: 'inline-flex',
					flexDirection: 'row',
				}}
			>
				<Logo />
				<Typography
					variant="inherit"
					sx={{
						color: 'primary.main',
						ml: 1,
						fontWeight: 'bold',
						alignItems: 'center',
						display: 'flex',
					}}
				>
					ADAP HUB ADMIN
				</Typography>
			</Box>

			<Box sx={{ m: 1 }}>
				<Link underline="none" component={RouterLink} to="#">
					<AccountStyle>
						<Avatar src={auth()?.user_profile} alt="photoURL" />
						<Box sx={{ ml: 1 }}>
							<Typography variant="subtitle2" sx={{ color: 'text.primary' }}>
								{`${auth()?.fullname?.firstname} ${auth()?.fullname?.lastname}`}
							</Typography>
							<Typography variant="body2" sx={{ color: 'text.secondary' }}>
								{'ADMIN'}
							</Typography>
						</Box>
					</AccountStyle>
				</Link>
			</Box>

			<NavSectionVertical navConfig={navConfig} />

			<Box sx={{ flexGrow: 1, mb: 5 }} />
			<br />
		</Scrollbar>
	);

	console.log('render sidebar');

	return (
		<RootStyle>
			{!isDesktop && (
				<Drawer
					open={isOpenSidebar}
					onClose={onCloseSidebar}
					PaperProps={{
						sx: { width: DRAWER_WIDTH },
					}}
				>
					{renderContent}
				</Drawer>
			)}

			{isDesktop && (
				<Drawer
					open
					variant="persistent"
					PaperProps={{
						sx: {
							width: DRAWER_WIDTH,
							bgcolor: 'background.default',
							borderRightStyle: 'dashed',
							transition: (theme) =>
								theme.transitions.create('width', {
									duration: theme.transitions.duration.standard,
								}),
						},
					}}
				>
					{renderContent}
				</Drawer>
			)}
		</RootStyle>
	);
};

DashboardSidebar.propTypes = {
	isOpenSidebar: PropTypes.bool,
	onCloseSidebar: PropTypes.func,
};

export default DashboardSidebar;
